{
  "name": "@tramme/editor",
  "version": "0.20.0",
  "license": "FSL-1.1-ALv2",
  "private": true,
  "type": "module",
  "exports": {
    ".": "./src/main.tsx"
  },
  "dependencies": {
    "@jitsi/rnnoise-wasm": "^0.2.1",
    "@mediapipe/tasks-vision": "^1.1.1",
    "@tramme/api": "*"
  }
}
